import React from 'react';
import StorefrontManager from './StorefrontManager';

export default function StorefrontManagerSection(props) {
    return <StorefrontManager {...props} />;
}
